import { gql, useQuery } from "utils/urql";
import Image from "components/Image";
import styles from "./ArticleRelatedContentMagazine.module.scss";
import {
  MagazineRelatedContentQuery,
  MagazineRelatedContentQueryVariables,
} from "types/api";

const MAGAZINE_RELATED_QUERY = gql`
  query MagazineRelatedContentQuery($id: ID!, $preview: String) {
    article(id: $id, preview: $preview) {
      ... on MagazineArticle {
        issue {
          issueName
          url
          cover(width: 100, height: 133, sizes: ["100w", "200w"]) {
            id
            url
            srcSet
            width
            height
          }
        }
      }
    }
  }
`;

const ArticleRelatedContentMagazine = ({
  id,
  preview,
}: {
  id: string;
  preview?: string | null;
}) => {
  const [{ data }] = useQuery<
    MagazineRelatedContentQuery,
    MagazineRelatedContentQueryVariables
  >({
    query: MAGAZINE_RELATED_QUERY,
    variables: {
      id,
      preview,
    },
  });
  const content =
    data?.article.__typename === "MagazineArticle" && data.article.issue;
  if (!content) return null;
  return (
    <section className={styles.root}>
      {content.cover && (
        <figure className={styles.figure}>
          <a
            href={content.url}
            title={`Read More from the ${content.issueName} issue`}
            data-action="link click - magazine promo"
            data-label={content.url}
          >
            <picture className={styles.picture}>
              <Image
                className={styles.image}
                alt=""
                width={content.cover.width}
                height={content.cover.height}
                src={content.cover.url}
                srcSet={content.cover.srcSet}
                lazy
              />
            </picture>
          </a>
        </figure>
      )}
      <div className={styles.textWrapper}>
        <h2
          className={styles.heading}
        >{`From our ${content.issueName} issue`}</h2>
        <p className={styles.cta}>
          Check out the full table of contents and find your next story to read.
        </p>
      </div>
      <a
        className={styles.link}
        href={content.url}
        target="_blank"
        rel="noopener noreferrer"
        data-action="click button - magazine promo"
        data-label={content.url}
      >
        See More
      </a>
    </section>
  );
};

export default ArticleRelatedContentMagazine;
